import { Component, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormArray, FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { FormSelectButtonComponent } from '@shared/forms';
import { CURRENCIES, CurrencyCode, DEFAULT_CURRENCY } from '../currency';
import { TierFormGroup } from '../types';
import { TierRowComponent } from './tier-row/tier-row.component';
import { createTierGroup } from '../pricing-form';

@Component({
    selector: 'app-tier-pricing-editor',
    templateUrl: './tier-pricing-editor.component.html',
    styleUrls: ['./tier-pricing-editor.component.css'],
    imports: [ReactiveFormsModule, TranslateModule, ButtonModule, FormSelectButtonComponent, TierRowComponent],
})
export class TierPricingEditorComponent {
    readonly tiers = input.required<FormArray<TierFormGroup>>();
    readonly testId = input.required<string>();

    readonly currencyControl = new FormControl<CurrencyCode>(DEFAULT_CURRENCY, { nonNullable: true });
    readonly currencyOptions = CURRENCIES.map((currency) => ({ label: currency, value: currency }));
    readonly activeCurrency = toSignal(this.currencyControl.valueChanges, { initialValue: this.currencyControl.value });

    addTier(): void {
        const tiers = this.tiers();
        const last = tiers.at(tiers.length - 1);
        const seedMin = last ? (last.controls.maxUsers.value ?? last.controls.minUsers.value) + 1 : 1;
        tiers.push(createTierGroup({ minUsers: seedMin }));
    }

    removeTier(index: number): void {
        this.tiers().removeAt(index);
    }
}
